import type { SVGProps } from 'react';

interface DairyIconProps extends SVGProps<SVGSVGElement> {
  className?: string;
}

export function DairyIcon({ className, ...props }: DairyIconProps) {
  return (
    <svg
      width="27"
      height="16"
      viewBox="0 0 27 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      aria-hidden="true"
      {...props}
    >
      <path d="M26.8353 0.00152891C26.983 1.25065 26.2239 2.31935 25.1112 2.85753C25.6047 3.75194 26.3512 4.65858 26.7976 5.56216C27.038 6.04682 27.1386 6.13091 26.6718 6.50855C26.2286 6.86632 25.6141 7.17668 25.1489 7.52527C24.6916 7.18739 24.3851 6.49938 23.6998 6.74553L20.0143 10.3262C19.8226 10.5663 19.3856 11.346 19.3856 11.6197V16H16.4844V11.0097L16.3665 10.895H7.89843L7.79313 11.0219C7.76327 12.511 6.3865 13.3076 4.95786 13.1807V16H2.05659V7.54362C1.70926 7.74085 1.36192 7.95337 0.96272 8.04357C-0.231737 8.31266 0.0275859 8.03746 0.0165843 7.01003C1.02401 7.07425 1.94972 6.45351 2.05502 5.44749C2.22319 3.83602 1.52694 2.06861 3.97401 1.90196L24.2861 1.90502C25.1945 1.73225 25.8106 0.892881 25.7367 0H26.8337L26.8353 0.00152891Z" fill="currentColor" />
    </svg>
  );
}
